module.exports = __webpack_public_path__ + "static/lframe-home-38e72ea4af821380d437f8a9fe7576d4.png";